import { withCompInfo } from '../../core/withCompInfo'
import { LoginButtonDefinition, LoginButtonCSSVars } from './types'

export const css = withCompInfo<LoginButtonCSSVars, LoginButtonDefinition>(['compLayout'], ({ compLayout }) => {
	return {
		height: 'auto',
		'min-height': `${compLayout.height}px`,
	}
})
